import ProTip from '../ProTip'

export default function ContentSection() {
  return (
    <>
      <p className="text-sm text-muted-foreground mb-2">
        The Content module is your file cabinet inside the CRM. Store proposals, contracts,
        presentations, product sheets, and any other documents your team needs — all linked to the
        records they belong to.
      </p>
      <p className="text-sm text-muted-foreground mb-2">
        <span className="font-medium">To upload a file:</span>
      </p>
      <ol
        className="list-decimal list-inside space-y-1 text-sm text-muted-foreground ml-2"
        role="list"
      >
        <li>
          Go to <span className="font-medium">Content</span> in the sidebar
        </li>
        <li>
          Click <span className="font-medium">Upload</span> and select your file
        </li>
        <li>Add a description and link it to an account, contact, or opportunity</li>
        <li>
          Click <span className="font-medium">Save</span>
        </li>
      </ol>
      <p className="text-sm text-muted-foreground mt-2 mb-2">
        You can also attach files directly from an opportunity's Attachments tab. Files support
        versioning, so you can upload updated versions without losing the originals.
      </p>
      <p className="text-sm text-muted-foreground mb-3">
        <span className="font-medium">Finding files:</span> Use the search bar and filters on the
        Content page to locate files by name, type, date, or related record.
      </p>

      <ProTip>
        <span className="font-medium">Stay organized:</span> Attach your proposals and contracts to
        the relevant opportunity. When it is time for a renewal or upsell, you will have the full
        history at your fingertips without digging through email.
      </ProTip>
    </>
  )
}
